import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { DropdownButton, NavItem, MenuItem, NavDropdown } from 'react-bootstrap';
import { find, each } from 'lodash';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import styles from './styles.css';

function NavDropDown(props) {
  const { location, organization, hasNominations } = props;
  const { pathname } = location;
  const links = [
    {
      url: '/setup/filters',
      label: 'Manage Filters',
    },
  ];

  const isDemo = organization && organization.is_demo;

  if (!isDemo) {
    links.push(null);

    links.push({
      url: '/setup/sync-settings',
      label: 'Sync Settings',
    });
    links.push({
      url: '/setup/amount',
      label: 'Opportunity Amount',
      hidden: true,
    });
    links.push({
      url: '/setup/deal-types',
      label: 'Opportunity Type',
      hidden: true,
    });
    links.push({
      url: '/setup/owner',
      label: 'Owner',
      hidden: true,
    });
    if (organization.type !== 'hubspot') {
      links.push({
        url: '/setup/user-types',
        label: 'Users',
        hidden: true,
      });
    }
    links.push({
      url: '/setup/close-date',
      label: 'Opportunity Close Date',
      hidden: true,
    });
    links.push({
      url: '/setup/products',
      label: 'Products',
      hidden: true,
    });
    links.push({
      url: '/setup/forecast-categories',
      label: 'Forecast Categories',
      hidden: true,
    });
    links.push({
      url: '/setup/industries',
      label: 'Industry',
      hidden: true,
    });
    links.push({
      url: '/setup/account-size',
      label: 'Account Size',
      hidden: true,
    });

    links.push({
      url: '/setup/sales-stages',
      label: 'Sales Stages',
    });
    links.push({
      url: '/setup/currency',
      label: 'Currency Setup',
    });
    links.push({
      url: '/setup/conversion-rates',
      label: 'Conversion Rates',
    });
    links.push({
      url: '/setup/exclusion-reasons',
      label: 'Exclusion Reasons',
    });
  }

  // if (hasNominations) {
  links.push(null);
  links.push({
    url: '/setup/feedback-requests',
    label: 'Feedback Requests',
  });
  links.push({
    url: '/setup/custom-do-not-contact-field',
    label: 'Do Not Contact Fields',
  });
  links.push({
    url: '/setup/truvoice-fields',
    label: 'TruVoice Fields',
  });
  links.push({
    url: '/setup/truvoice-products',
    label: 'TruVoice Products',
  });
  links.push({
    url: '/setup/feedback-languages',
    label: 'Language Settings',
  });
  links.push({
    url: '/setup/truvoice-tags',
    label: 'TruVoice Tags',
  });
  links.push({
    url: '/setup/update-truvoice-data',
    label: 'Update TruVoice Data',
  });
  /*
  links.push({
    url: '/setup/truvoice-collectors',
    label: 'Survey Collectors',
  });
  */
  links.push({
    url: '/setup/leaderboard',
    label: 'Leaderboard',
  });
  links.push({
    url: '/setup/benchmarks',
    label: 'Benchmarks',
  });
  // }

  /*
  links.push({
    url: '/setup/email-alerts',
    label: 'Email Alerts',
  });
  */

  links.push(null);

  links.push({
    url: '/setup/user-permissions',
    label: 'Module & Data Access',
    disabledOnDemo: true,
  });
  links.push({
    url: '/setup/feedback-module',
    label: 'Feedback Module Tiles',
  });
  links.push({
    url: '/setup/quick-search',
    label: 'Quick Search',
  });
  links.push({
    url: '/setup/users',
    label: 'Manage Users',
    disabledOnDemo: true,
  });

  if (!isDemo) {
    links.push(null);
    links.push({
      url: '/setup/organization',
      label: 'Organization',
    });
  }

  const activeItem = find(links, l => l !== null && pathname.indexOf(l.url) === 0);

  return (
    <DropdownButton pullRight bsStyle="default" title={activeItem !== undefined ? activeItem.label : 'Setup'} id="setup-nav">
      {links.map((link, idx) => {
        if (!link) {
          return <MenuItem key={idx} divider />;
        }
        if (isDemo && link.disabledOnDemo) {
          return null;
        }
        if (link.hidden) {
          return null;
        }

        const itm = (
          <LinkContainer key={link.url} to={link.url}>
            <NavItem>{link.label}</NavItem>
          </LinkContainer>
        );

        if (link.url === '/setup/sync-settings') {
          const itms = [];
          let active = false;

          each(links, (menu) => {
            if (menu && menu.hidden) {
              if (pathname.indexOf(menu.url) === 0) {
                active = true;
              }
              itms.push((
                <LinkContainer key={menu.url} to={menu.url}>
                  <NavItem>{menu.label}</NavItem>
                </LinkContainer>
              ));
            }
          });

          if (!active && pathname.indexOf(link.url) === 0) {
            active = true;
          }

          return (
            <NavDropdown key="collapse" title={link.label} className={`${styles.dropDown} ${active ? 'active' : ''}`} id="collapse-nav-dropdown">
              {itm}
              {itms}
            </NavDropdown>
          );
        }
        return itm;
      })}
    </DropdownButton>
  );
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const organization = getUserCurrentOrganization(state);
  const hasNominations = organization && organization.features && organization.features.nominations;
  return {
    organization,
    hasNominations,
  };
}

NavDropDown.propTypes = {
  location: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  hasNominations: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(NavDropDown);
